export default __webpack_public_path__ + "static/media/expert.1574db83.png";